<template>
  <div class="expand-sub-table-wrap">
    <a-table
      class="expand-sub-table"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
      row-key="id"
      size="small"
    >
      <span slot="assignPersonnelTitle" class="assign-personnel-title">
        <span>分配人员(编号x数量)</span>
        <a-button type="primary" size="small" :loading="saveLoading" @click.stop="handleSave">保存</a-button>
      </span>
      <template slot="assignedPersonnel" slot-scope="text, row">
        <assign-personnel-cell
          :record="row"
          @change="handleAssignmentChange(row.id, $event)"
        />
      </template>
      <template slot="schedulingDate" slot-scope="text, row">
        <a-date-picker
          v-model="row.schedulingDate"
          size="small"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          allow-clear
          placeholder="请选择"
          class="cell-date-picker"
        />
      </template>
      <template slot="remark" slot-scope="text, row">
        <a-input
          v-model="row.remark"
          size="small"
          allow-clear
          placeholder="请输入备注"
          class="cell-remark-input"
        />
      </template>
      <template slot="statusName" slot-scope="text">
        <span :class="statusClass(text)">{{ text }}</span>
      </template>
      <template slot="operation" slot-scope="text, row">
        <a-button type="link" class="link-btn" @click="handleLog(row)">日志</a-button>
      </template>
    </a-table>
    <operation-log-model
      ref="operationLogModelRef"
      :logLoading="logLoading"
      :logList="logList"
      @closeLog="closeLogFun"
    />
  </div>
</template>

<script>
import AssignPersonnelCell from './assign-personnel-cell.vue'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import {
  apiMesProcessSchedulingAssignLines,
  apiMesSelectMesWipLogList
} from '@/api/mes/workOrderManage/ouKangOrderScheduling'

export default {
  name: 'ExpandSubTable',
  components: {
    AssignPersonnelCell,
    OperationLogModel
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      saveLoading: false,
      logLoading: false,
      logList: [],
      assignmentPayloadByLine: {},
      columns: [
        { title: '子工序', dataIndex: 'subProcessCodeName', width: 150, ellipsis: true },
        { title: '计划数量', dataIndex: 'planQuantity', width: 100, align: 'right' },
        {
          dataIndex: 'assignmentList',
          width: 600,
          slots: { title: 'assignPersonnelTitle' },
          scopedSlots: { customRender: 'assignedPersonnel' }
        },
        {
          title: '排单日期',
          dataIndex: 'schedulingDate',
          width: 200,
          scopedSlots: { customRender: 'schedulingDate' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 250,
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '排单状态',
          dataIndex: 'statusName',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'statusName' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  computed: {
    list () {
      return this.record.lineList || []
    }
  },
  methods: {
    closeLogFun () {
      this.logLoading = false
      this.logList = []
    },
    handleLog (row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiMesSelectMesWipLogList({ id: row.id, type: 14 }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.logList = res.data
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    getLineAssignmentPayload (row) {
      if (Object.prototype.hasOwnProperty.call(this.assignmentPayloadByLine, row.id)) {
        return this.assignmentPayloadByLine[row.id]
      }
      return (row.assignmentList || []).map(item => ({
        id: item.id,
        assignedPersonnel: item.assignedPersonnel,
        assignedQuantity: item.assignedQuantity,
        deleted: item.deleted === true || item.deleted === 1
      }))
    },
    handleAssignmentChange (lineId, assignmentList) {
      this.$set(this.assignmentPayloadByLine, lineId, assignmentList)
    },
    validateAssignmentCells () {
      return this.list.every(row => {
        const assignments = this.getLineAssignmentPayload(row).filter(item => !item.deleted)
        const personnelList = assignments.map(item => item.assignedPersonnel).filter(Boolean)
        const rowName = row.subProcessCodeName || '当前行'
        if (new Set(personnelList).size !== personnelList.length) {
          this.$message.warning(`${rowName}分配人员编码不能重复`)
          return false
        }
        const assignedQuantity = assignments.reduce((total, item) => {
          return total + Number(item.assignedQuantity || 0)
        }, 0)
        if (assignedQuantity > Number(row.planQuantity || 0)) {
          this.$message.warning(`${rowName}累计分配人员数不能大于计划数量`)
          return false
        }
        return true
      })
    },
    buildAssignLinesPayload () {
      return this.list.map(row => ({
        lineId: row.id,
        schedulingDate: row.schedulingDate || null,
        remark: row.remark || null,
        assignmentList: this.getLineAssignmentPayload(row)
      }))
    },
    async handleSave () {
      if (!this.validateAssignmentCells()) {
        return
      }
      this.saveLoading = true
      try {
        const res = await apiMesProcessSchedulingAssignLines(this.buildAssignLinesPayload())
        if (res.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } finally {
        this.saveLoading = false
      }
    },
    statusClass (statusName) {
      return {
        'status-done': statusName === '已排单',
        'status-part': statusName === '部分排单'
      }
    }
  }
}
</script>

<style scoped lang="less">
.expand-sub-table-wrap {
  width: 99%;
  margin: 0 auto;
  padding-left: 60px;
  box-sizing: border-box;
}

.expand-sub-table {
  /deep/ table {
    table-layout: auto !important;
  }
  /deep/ .ant-table-content,
  /deep/ .ant-table-body,
  /deep/ .ant-table-scroll {
    overflow-x: hidden !important;
  }
  /deep/ .ant-table-thead > tr > th {
    background: #f5f5f5;
    padding: 4px 6px;
    font-weight: 500;
    white-space: nowrap;
    font-size: 12px;
  }
  /deep/ .ant-table-tbody > tr > td {
    padding: 4px 6px;
    background: #fff;
    word-break: break-all;
    font-size: 12px;
  }
}

.assign-personnel-title {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.cell-date-picker,
.cell-remark-input {
  width: 100%;
}

.status-done {
  color: #52c41a;
}

.status-part {
  color: #fa8c16;
}

.link-btn {
  padding: 0;
  height: unset;
}
</style>
